import { Eligibility } from "./Eligibility/Eligibility";
import { RewardKeysAnimation } from "./RewardKeysAnimation";
import { RewardsBanner } from "./RewardsBanner";
import { TranslucentContainer } from "./TranslucentContainer";

export function RewardsOnboarding({ hasFreeEntry }: { hasFreeEntry: boolean }) {
  const isFromReferral = hasFreeEntry;
  const onboardingTitle = isFromReferral
    ? "Qualify and get your free key and 300 Gems!"
    : "Qualify to join the weekly draw and claim your weekly rewards!";

  const onboardingDescription = isFromReferral
    ? "Link at least one social account, and verify your phone number. The moment you finish, you will get a free entry to the weekly draw."
    : "Link at least one social account, and verify your phone number. The moment you finish, you will be able to enter the weekly draw.";

  return (
    <TranslucentContainer>
      <RewardsBanner
        title={onboardingTitle}
        description={onboardingDescription}
        isLoading={false}
      />
      <Eligibility />
      <RewardKeysAnimation />
    </TranslucentContainer>
  );
}
